<div class="leaderboard-assets flex flex-col gap-6 w-full min-w-0">
  @if (leadershipMembers[0]; as top) {
    <article
      class="leaderboard-assets__featured relative overflow-hidden rounded-2xl p-6 md:p-8 flex flex-col gap-6 text-white shadow-[var(--shadow-elevated)]"
    >
      <div
        class="relative z-[1] flex w-full min-w-0 flex-col lg:flex-row lg:items-center lg:justify-between gap-6 lg:gap-8"
      >
        <div class="flex flex-col gap-4 min-w-0 flex-1 lg:max-w-[min(100%,36rem)] lg:pr-4">
          <span
            class="leaderboard-assets__badge inline-flex items-center gap-2 self-start rounded-full bg-white px-3 py-1.5 text-sm font-semibold"
          >
            <img src="/icons/crown.svg" width="18" height="18" alt="" />
            #1 Top Leader
          </span>
          <div class="min-w-0">
            <h2 class="text-2xl md:text-3xl font-bold m-0 leading-tight text-white">
              {{ top.name }}
            </h2>
            <p class="mt-2 m-0 text-base text-white/85">
              {{ subtitle(top) }}
            </p>
          </div>
        </div>
        <div class="leaderboard-assets__featured-stats w-full lg:w-auto">
          <div class="leaderboard-assets__stat-tile leaderboard-assets__stat-tile--datasets">
            <span class="leaderboard-assets__stat-label">Datasets</span>
            <span class="leaderboard-assets__stat-value leaderboard-assets__stat-value--datasets">
              <img src="/icons/vector-2-white.svg" width="40" height="40" alt="" aria-hidden="true" />
            </span>
          </div>
          <div class="leaderboard-assets__stat-tile">
            <span class="leaderboard-assets__stat-label">Upvotes</span>
            <span class="leaderboard-assets__stat-value">
              <img src="/icons/upload-white.svg" width="22" height="22" alt="" aria-hidden="true" />
              {{ top.likes ?? 0 }}
            </span>
          </div>
          <div class="leaderboard-assets__stat-tile">
            <span class="leaderboard-assets__stat-label">Downloads</span>
            <span class="leaderboard-assets__stat-value">
              <img src="/icons/thumbs-up-white.svg" width="22" height="22" alt="" aria-hidden="true" />
              {{ top.downloads ?? 0 }}
            </span>
          </div>
          <div class="leaderboard-assets__stat-tile">
            <span class="leaderboard-assets__stat-label">Views</span>
            <span class="leaderboard-assets__stat-value">
              <img src="/icons/download-white.svg" width="22" height="22" alt="" aria-hidden="true" />
              {{ top.views ?? 0 }}
            </span>
          </div>
        </div>
      </div>
    </article>
  }

  <ul class="flex flex-col gap-4 list-none m-0 p-0 w-full" role="list">
    @for (member of leadershipMembers.slice(1); track member.id) {
      <li
        class="leaderboard-assets__row flex flex-col md:flex-row md:items-center gap-4 rounded-2xl border border-[var(--border-neutral)] bg-white p-4 md:p-5 shadow-[var(--shadow-card)]"
      >
        <div class="leaderboard-assets__row-main flex items-center gap-4 min-w-0 flex-1">
          <span
            class="leaderboard-assets__rank shrink-0 inline-flex items-center justify-center w-10 h-10 rounded-full text-base font-bold text-[var(--leaderboard-teal-dark)]"
            >{{ member.rank }}</span
          >
          <div class="min-w-0 flex flex-col gap-1">
            <h3 class="m-0 text-lg font-bold text-[var(--text-primary-on-light)]">
              {{ member.name }}
            </h3>
            <p class="m-0 text-sm text-[var(--text-muted-on-light)]">
              {{ subtitle(member) }}
            </p>
          </div>
        </div>
        <div class="leaderboard-assets__row-metrics flex flex-wrap gap-3 shrink-0 w-full md:w-auto md:justify-end">
          <div class="leaderboard-assets__metric" data-variant="datasets">
            <span class="leaderboard-assets__metric-label">Datasets</span>
            <span class="leaderboard-assets__metric-value leaderboard-assets__metric-value--datasets">
              <img src="/icons/vector-3-black.svg" width="28" height="28" alt="" aria-hidden="true" />
            </span>
          </div>
          <div class="leaderboard-assets__metric" data-variant="upvotes">
            <span class="leaderboard-assets__metric-label">Upvotes</span>
            <span class="leaderboard-assets__metric-value leaderboard-assets__metric-value--upvotes">
              <img src="/icons/thumbs-up-green.svg" width="18" height="18" alt="" aria-hidden="true" />
              {{ member.likes ?? 0 }}
            </span>
          </div>
          <div class="leaderboard-assets__metric" data-variant="downloads">
            <span class="leaderboard-assets__metric-label">Downloads</span>
            <span class="leaderboard-assets__metric-value leaderboard-assets__metric-value--downloads">
              <img src="/icons/download-yellow.svg" width="18" height="18" alt="" aria-hidden="true" />
              {{ member.downloads ?? 0 }}
            </span>
          </div>
          <div class="leaderboard-assets__metric" data-variant="views">
            <span class="leaderboard-assets__metric-label">Views</span>
            <span class="leaderboard-assets__metric-value leaderboard-assets__metric-value--views">
              <img src="/icons/download-yellow.svg" width="18" height="18" alt="" aria-hidden="true" />
              {{ member.views ?? 0 }}
            </span>
          </div>
        </div>
      </li>
    }
  </ul>

  @if (showLoadMore) {
    <div class="flex justify-center pt-2">
      <button
        type="button"
        class="leaderboard-assets__load-more"
        (click)="emitLoadMore()"
        [disabled]="!assetsPagination.hasNext || assetsPagination.isLoading"
      >
        @if (!assetsPagination.isLoading) {
          <span>Load more</span>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true" class="shrink-0">
            <path
              d="M6 9L12 15L18 9"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        } @else {
          <span>Loading…</span>
        }
      </button>
    </div>
  }
</div>
